import * as cssVariable from 'cssVariables';
import { ANIMATION_TIME } from 'components/Tiles/StationTile/StationTile.const';
import { Styles } from 'jss';
export default (theme: StyleTheme): Styles => ({
  wrapper: {
    '& > div[data-key="tile-image"]:hover div[data-testid="hover-overlay"]': {
      display: 'flex',
      '& div[data-testid="is-playing-overlay"]': {
        display: 'none',
      },
    },
  },
  isPlayingWrapper: {},
  '@keyframes fadeIn': {
    from: {
      opacity: '0',
    },
    to: {
      opacity: '1',
    },
  },
  tile: {
    position: 'relative',
    backgroundColor: theme.palette.backgroundSecondary,
    borderRadius: cssVariable.borderRadius.default,
    paddingTop: '100%',
    transition: `transform ${ANIMATION_TIME} ease-in`,
    backgroundSize: '100%',
  },
  nonTouchTile: {
    '&:hover': {
      transform: 'scale(1.05)',
      cursor: 'pointer',
    },
  },
  isPlayingWrapperClass: {
    width: 'auto',
    height: 'auto',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 5,
    '& > button': {
      '&:hover': {
        color: cssVariable.green500,
      },
    },
  },
  content: {
    position: 'absolute',
    bottom: 5,
    width: '100%',
    height: '37%',
  },
  logo: {
    width: '80%',
  },
  jukeLogo: {
    position: 'initial',
    top: 'auto',
    bottom: 'auto',
    left: 0,
    width: '40%',
    transform: 'translate(0, 0)',
  },
  title: {
    margin: 0,
    color: cssVariable.white,
    fontSize: '21px',
    lineHeight: 1,
    marginTop: 5,
    padding: [0, 5],
    textAlign: 'center',
    textTransform: 'uppercase',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  touch: {
    fontSize: 16,
  },

  [`@media (max-width: ${theme.breakpoints.values.sl}px)`]: {
    title: {
      fontSize: 16,
    },
  },
});
